import types, { dataTypes, seasonStatsMap } from '../config/BoxscoreTypes';
import headers from '../config/columns';

const { BATTING, PITCHING } = types;
const getDisplayBattingOrder = (data) => {
    const battingOrder = data.battingOrder;
    return battingOrder && battingOrder.substring(1) === '00' ? battingOrder.charAt(0) : '';
};

const getTableHeader = (config) => {
    const { type } = config;
    const baseHeader = headers[type];
    return baseHeader;
};

const getTableBody = (opts) => {
    const { players, type, isInProgress, teamStats, language, totalsLabel } = opts;

    if (players && players.length === 0) {
        return {
            rows: [],
            currentBatterIndex: undefined
        };
    }

    let hasCurrentBatter;
    let currentBatterIndex;

    const rows = players.map((data, index) => {
        const { position, gameStatus = {}, person: { boxscoreName, fullName, id, batSide, pitchHand } = {}, displayPositions, stats = {}, seasonStats = {}, battingOrder } = data;
        const { isSubstitute, isCurrentBatter } = gameStatus;
        const { note = '' } = stats[type] || {};
        const displayBo = getDisplayBattingOrder(data);
        const baseProps = {
            type,
            note,
            label: boxscoreName,
            playerFullName: fullName,
            playerId: id,
            language
        };
        let additionalProps = {};

        if (type === BATTING) {
            // ensure we dont override the current batter
            if (!hasCurrentBatter && isInProgress && isCurrentBatter && battingOrder) {
                hasCurrentBatter = true;
                currentBatterIndex = index;
            }
            additionalProps = {
                isCurrentBatter: (type === BATTING && isCurrentBatter),
                isSubstitute,
                displayPositions,
                displayBo: !isSubstitute && displayBo, // this logic needs to be confirmed
                position: displayPositions
            };
        }

        headers[type].slice(1).forEach(({ dataField }) => {
            let dataSrc;
            const isSeasonStats = seasonStatsMap[type]?.[dataField];
            const dataKey = dataTypes?.[type];

            switch (dataField) {
                case 'pitchHand':
                    dataSrc = pitchHand?.code;
                    break;
                case 'position':
                    dataSrc = position?.abbreviation;
                    break;
                case 'batSideCode':
                    dataSrc = batSide?.code;
                    break;
                default:
                    if (isSeasonStats) {
                        dataSrc = seasonStats[dataKey][dataField];
                    } else {
                        dataSrc = stats[dataKey][dataField];
                    }
            }

            additionalProps[dataField] = dataSrc;
        });

        return { ...baseProps, ...additionalProps };
    });

    // added total row
    const totalRow = (type === BATTING || type === PITCHING) ? { ...headers[type], ...teamStats, label: totalsLabel } : headers[type];

    /* delete ops, avg and era from total rows
        since they are from seasonStats and we are not showing those in the table
    */

    delete totalRow.ops;
    delete totalRow.avg;
    delete totalRow.era;
    if (type === BATTING || type === PITCHING) {
        rows.push(totalRow);
    }
    return {
        rows,
        currentBatterIndex
    };
};

export {
    getTableHeader,
    getTableBody
};
